import type { LiabilityBusinessFeatureConfig } from '../../../types/insurances/LiabilityBusinessFeatureConfig';

export const liabilityBusiness: LiabilityBusinessFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
